import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * Remembers the Voice AI session id when a call ends with a handoff reason.
 *
 * The id is stored on `rememberHandoffSession` and consumed by the connect wizard, which stamps it
 * as `aiVoiceChatSessionId` on the created entity (live chat / voice chat / open request). The
 * backend resolves the handoff ticket and links it atomically during that first save,
 * so no follow-up call is needed. `clearHandoff` runs after a successful create,
 * end chat / close chatbot. Channel Cancel must not clear it so the user can retry another channel.
 * Follow-up creates on an existing ticket (`ticketId`) never stamp `aiVoiceChatSessionId`, so a
 * pending mid-handoff id can safely survive visiting Conversations.
 */
export const useVoiceAiHandover = defineStore('voiceAiHandover', () => {
  const pendingAiSessionId = ref<string | null>(null);

  const rememberHandoffSession = (aiSessionId: string | null) => {
    pendingAiSessionId.value = aiSessionId;
  };

  const clearHandoff = () => {
    pendingAiSessionId.value = null;
  };

  return {
    pendingAiSessionId,
    rememberHandoffSession,
    clearHandoff,
  };
});
